import { useState, useEffect } from 'react';
import { client } from '../lib/sanity';

export const useOurServices = () => {
    const [data, setData] = useState({
        title: '',
        subtitle: '',
        description: '',
        services: [],
        loading: true,
        error: null
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const query = `*[_type == "ourServicesId"][0] {
                    title,
                    subtitle,
                    description,
                    services[] {
                        title,
                        description,
                        image
                    }
                }`;

                const result = await client.fetch(query);
                setData({
                    title: result?.title || '',
                    subtitle: result?.subtitle || '',
                    description: result?.description || '',
                    services: result?.services || [],
                    loading: false,
                    error: null
                });
            } catch (err) {
                setData(prev => ({
                    ...prev,
                    loading: false,
                    error: err.message
                }));
            }
        };

        fetchData();
    }, []);

    return {
        title: data.title,
        subtitle: data.subtitle,
        description: data.description,
        services: data.services,
        loading: data.loading,
        error: data.error,
    };
}; 